import React, { useState } from 'react'
import { CardBody, CardTitle, CardSubtitle, Row, Col, Container } from 'reactstrap'
import ButtonPrevWithLine from './ButtonPrevWithLine'
import ButtonNextWithLine from './ButtonNextWithLine'
import SelectableStates from './SelectableStates'
import ButtonPrev from './ButtonPrev'
import ButtonNext from './ButtonNext'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actionCreators from '../redux/actions'
import { getSelectedStateInfo } from '../redux/reducers'
function Slide2 ({ onNextRequested, onPrevRequested, onIncrementProgress, onDecrementProgress, formProps, set }) {
  const [nextIsDisabled, setNextIsDisabled] = useState(true)
  const stateSelectorDiv = document.querySelector(`#stateSelector`)
  const onPreviousRequested = () => {
    setNextIsDisabled(true)

    // handle the back button click if the dialog is open first.
    // if dialog is open, hide it, and reset the left columns image source to original
    // allowing the user to select a new state
    if (overlayElm.style.display !== 'none' && zipCodeModal.style.display !== 'none') {
      // hide modals
      overlayElm.style.display = 'none'
      zipCodeModal.style.display = 'none'
      // hide state label and reset image filter style
      selectedStateLabel.innerHTML = ``
      leftImageIcon.style.filter = ``
      // change img src
      leftImageIcon.setAttribute('src', leftIconImageSource)
      leftStateImage.style.display = 'none'
      // show initial left column
      document.querySelector('#leftColumnTwo').style.display = 'none'
      document.querySelector('#leftColumnOne').style.display = 'block'
      // increase image width since its source is the icon now
      leftImageIcon.style.width = `280px`
      stateSelectorDiv.classList.remove('in')
      set('state', '')
      return
    }
    // other wise, call the base on previous requested which will navigate user to slide 1
    onPrevRequested()
  }

  const selectedStateLabel = document.querySelector('#selectedStateLabel')
  const leftImageIcon = document.querySelector('#leftIconImage')
  const leftStateImage = document.querySelector('#leftStateImage')

  const overlayElm = document.querySelector(`#overlay`)
  const zipCodeModal = document.querySelector(`#zipCodeModal`)
  // state was selected from SelectableStates component
  // handle updating the image on the left column and displaying of the state's label

  // as well as showing the overlay & associated zip code entry dialog
  const handleStateSelection = (event) => {
    const selectedState = {
      stateName: event.target.getAttribute('id'),
      imageSrc: event.target.getAttribute('src')
    }

    set('state', selectedState.stateName)
    // show elements
    overlayElm.style.display = 'block'
    zipCodeModal.style.display = 'flex'
    leftStateImage.style.display = 'block'
    const stateObject = getSelectedStateInfo(selectedState.stateName)
    selectedStateLabel.innerHTML = stateObject.state
    // update images width, decrease width to display state, set to grey opacity
    leftStateImage.style.filter = overlayFilter
    leftStateImage.setAttribute('src', selectedState.imageSrc)

    document.querySelector('#leftColumnOne').style.display = 'none'
    document.querySelector('#leftColumnTwo').style.display = 'block'
    onIncrementProgress()
    setNextIsDisabled(false)
  }
  const exitViewWrapper = document.querySelector('.SorrySlide')
  const mainViewWrapper = document.querySelector('#mainWrapper')

  const zipCodeInputElm = document.querySelector(`#inputZipCode`)
  const zipCodeErrorElm = document.querySelector(`#zipCodeError`)
  const showExitView = (e) => {
    e.preventDefault()
    e.stopPropagation()

    mainViewWrapper.classList.add('d-none')
    exitViewWrapper.classList.remove('d-none')
  }
  const overlayFilter = `grayscale(100%) opacity(0.20)`

  let leftIconImageSource = '/assets/graphic-loc.svg'

  const onPrevClick = () => {
    onDecrementProgress()
    onPreviousRequested()
  }

  const onNextClick = () => {
    if (!zipCodeInputElm.value || !zipCodeInputElm.value.length) {
      zipCodeErrorElm.innerHTML = `The zip code you entered is incorrect.`
      return
    }

    if (zipCodeInputElm.value && zipCodeInputElm.value.length < 5) {
      zipCodeErrorElm.innerHTML = `The zip code you entered is incorrect.`
      return
    } else if (zipCodeInputElm.value && zipCodeInputElm.value.length === 5) {
      zipCodeErrorElm.innerHTML = ``
    }

    onIncrementProgress()
    onNextRequested()
  }

  const onZipCodeChanged = (e) => {
    set('zip', e.target.value)
  }

  const redirectToSFB = (e) => {
    e.preventDefault()
    e.stopPropagation()

    window.location.href = `https://www.sfbli.com/`
  }

  return (
    <CardBody className='Slide2 app-slide w-100'>
      <Container id='mainWrapper' fluid style={{ padding: 0, width: '100%', maxWidth: 1500 }}>

        <Row className={'d-flex'}>
          <Col xs={{ size: 12, order: 2 }} xl={{ order: 1, size: 6 }} id='leftColumnOne' className='mt-xl-5 pt-xl-5'>
            <CardBody id='left-grid' style={{ maxWidth: '100%', float: 'left', display: 'flex' }}>
              <aside className='d-none d-xl-flex align-items-center justify-content-start align-content-start' style={{ width: 300 }}>
                <img alt='' id='leftIconImage' src={leftIconImageSource} style={{ width: '100%', height: 'auto', maxWidth: 200, marginTop: '-40px' }} className='img-fluid pr-xl-5 mr-2' />
              </aside>
              <div>
                <CardTitle>
                  <h2 className='d-none d-xl-flex '>Which State do you live in?</h2>
                </CardTitle>
                <CardSubtitle>
                  <p style={{ width: '95%', margin: 'auto' }} className='mt-xl-4 ml-xl-0 col-sm-12 col-xl-10 text-wrap p-0'>SFB provides life insurance coverage in these states. To best help you, please enter your zip code.</p>
                </CardSubtitle>
              </div>
            </CardBody>
          </Col>

          <Col xs={{ size: 12, order: 2 }} xl={{ size: 6, order: 2 }} id='leftColumnTwo' className='mt-xl-4 pt-xl-5' style={{ display: 'none' }}>
            <Row className='mt-xl-5 d-xl-flex d-none'>
              <div className='col-xl-4'>
                <img alt='' id='leftStateImage' src={leftIconImageSource} style={{ height: 'auto', maxWidth: 329, maxHeight: 270, width: `100%` }} className='img-fluid pr-xl-4 mr-xl-2 mt-xl-5 m-auto' />
                <label className='help-block' id='selectedStateLabel' />
              </div>
              <div className='col-xl-8'>
                <CardTitle>
                  <h2>What’s your zip code?</h2>
                </CardTitle>
                <CardSubtitle>
                  <p className='col-sm-12 col-md-8 text-wrap p-0 pt-4'>Enter your zip and we’ll find a local agent to help provide the recommended life insurance needed to protect your family.</p>
                </CardSubtitle>
              </div>
            </Row>
          </Col>

          <div>
            <div className='d-xl-flex d-none align-items-center pull-left' style={{ position: 'relative', left: '850px', top: '80px', zIndex: 99 }}>
              <ButtonPrevWithLine onClick={onPrevClick} />
            </div>
          </div>

          <Col xs={{ size: 12, order: 1 }} xl={{ size: 5, order: 2 }} className='mt-xl-5 ml-xl-5 pl-xl-5'>
            <CardTitle>
              <h4 className='h4-spaced text-center text-blue text-bold p-2'>WHICH STATE DO YOU LIVE IN?</h4>
            </CardTitle>
            <CardSubtitle>
              <h5 className='text-center text-blue'>
                Don’t see your state?
                <a className='text-bold text-blue' onClick={showExitView} style={{ cursor: 'pointer' }}> CLICK HERE.</a>
              </h5>
            </CardSubtitle>
            <div id='stateWrapper' >
              <SelectableStates onZipCodeChanged={onZipCodeChanged} formProps={formProps} handleStateSelection={handleStateSelection} />
            </div>
          </Col>

          <div id={'slide2NextBtn'} style={{ position: 'relative', left: '1500px', bottom: -80 }} >
            <ButtonNextWithLine onClick={onNextClick} disabled={nextIsDisabled} />
          </div>
        </Row>
        <Row>
          <div className='d-flex justify-content-between d-xl-none mt-5 col-12' style={{ position: 'relative', left: 0 }}>
            <div style={{ position: 'relative', left: 20 }}>
              <ButtonPrev onClick={onPrevClick} />
            </div>
            <div style={{ position: 'relative', right: 20 }}>
              <ButtonNext onClick={onNextClick} disabled={nextIsDisabled} />
            </div>
          </div>
        </Row>
      </Container>
      <Container className='SorrySlide app-slide w-100 d-none' fluid style={{ padding: 0, width: '100%', maxWidth: 1500 }}>
        <Row>
          <Col xs={{ size: 12 }} xl={{ size: 6 }} className='center-block pt-xl-5'>
            <div className='d-xl-flex justify-content-between align-items-start'>

              <Col xs={{ size: 12 }} xl={{ size: 4 }}>
                <img id='leftIconImage' src={leftIconImageSource} className='img-fluid mt-xl-5 pt-xl-4' />
              </Col>

              <Col xs={{ size: 12 }} xl={{ size: 8 }}>
                <CardTitle>
                  <h2 className='d-flex'>We're sorry.</h2>
                </CardTitle>
                <CardSubtitle>
                  <p style={{ fontSize: '23px' }} className='mt-xl-4 ml-xl-0 col-sm-12 col-xl-12 text-wrap p-0'>Southern Farm Bureau Life Insurance Company does not provide coverage in your state. We recommend that you continue your search for life insurance coverage to protect your family with another insurance company.</p>
                </CardSubtitle>
                <div className='d-xl-block d-flex justify-content-center'>
                  <button style={{ width: 215, margin: 'auto' }} onClick={redirectToSFB} className='btn-begin btn btn-secondary btn-exit mt-4'>Exit Calculator</button>
                </div>
              </Col>
            </div>
          </Col>

          <Col xs={{ size: 12 }} xl={{ size: 6 }} className='mt-xl-5  pl-xl-5'>
            <Container fluid className='p-0 d-xl-flex d-none' style={{ filter: overlayFilter, zoom: `130%`, position: 'relative' }}>
              <SelectableStates />
            </Container>
          </Col>

        </Row>
      </Container>
    </CardBody>)
}

const mapStateToProps = (state, props) => ({
  formProps: {
    zip: state.app.zip,
    state: state.app.state,
    hasClickedState: state.app.hasClickedCantFindState
  }
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Slide2)
